import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Breadcrumbs from "@/components/Breadcrumbs";
import { business } from "@/data/site";

const Block = ({ title, children }) => (
  <div className="mt-8">
    <h2 className="font-heading text-xl font-bold text-forest">{title}</h2>
    <div className="mt-3 space-y-3 text-sm leading-relaxed text-charcoal/75">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Benji's Hauling & Junk Removal"
        description="How Benji's Hauling & Junk Removal collects, uses, and protects the information you share when requesting an estimate or contacting us."
        path="/privacy-policy"
      />
      <Breadcrumbs items={[{ label: "Privacy Policy" }]} />
      <PageHero eyebrow="Legal" title="Privacy Policy" sub="Your trust matters to us. This page explains how we handle the information you share with Benji's Hauling & Junk Removal." />

      <section className="bg-cream py-16">
        <div className="container-x max-w-3xl">
          <Block title="Information We Collect">
            <p>When you contact us or submit an estimate request, we may collect details you provide such as your name, phone number, email address, service address, and a description of the items you'd like removed. We only ask for what we need to provide an estimate and schedule service.</p>
          </Block>
          <Block title="How We Use Your Information">
            <p>We use your information to respond to inquiries, prepare estimates, coordinate service, and follow up about your request. We do not sell your personal information.</p>
          </Block>
          <Block title="How We Share Information">
            <p>We do not share your personal information with third parties except as needed to operate our business (for example, communication tools) or as required by law.</p>
          </Block>
          <Block title="Data Retention">
            <p>We keep the information you provide only as long as reasonably necessary to serve you and to maintain accurate business records.</p>
          </Block>
          <Block title="Your Choices">
            <p>You may request that we update or remove your information by contacting us at {business.email}. You can also opt out of non-essential communications at any time.</p>
          </Block>
          <Block title="Contact Us">
            <p>Questions about this policy? Reach out at {business.phoneDisplay} or {business.email}. You can also head back to our <Link to="/contact" className="font-semibold text-gold-dark hover:underline">contact page</Link>.</p>
          </Block>
          <p className="mt-10 text-xs text-mutedgreen">This policy is provided as a starting template and can be customized with the owner's finalized legal details.</p>
        </div>
      </section>
    </>
  );
}
